import React, { Component } from 'react';
import "../styles/bangerText.css";

export default class BangerText extends Component {
  render() {
    return (
      <div className="medium-max-width-container">
        <div className="banger-text">
          <div className="banger-text-accent"></div>
          <h2>{this.props.text}</h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bangerText.js